import React, { useState } from 'react';
import { TagIcon, CopyIcon, CheckIcon, ArrowRightIcon } from 'lucide-react';
import { discountOffer } from '../data/product';
const REDIRECT_URL = 'https://gritvuegear.com';
export function DiscountSection() {
  const [copied, setCopied] = useState(false);

  // Copies the code, shows "Copied" for a beat, then sends the visitor to gritvuegear.com.
  const handleCopy = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(discountOffer.code).catch(() => undefined);
    }
    setCopied(true);
    window.setTimeout(() => {
      window.location.href = REDIRECT_URL;
    }, 600);
  };
  return <section aria-labelledby="discount-heading" className="border-b border-white/10 bg-grit-500" data-id="element-487" data-mp="1m8mtkpm4ydpd">
      <div className="mx-auto max-w-[1400px] px-4 py-12 sm:px-6 lg:px-8 lg:py-16" data-id="element-488" data-mp="1hgcxssycajf6">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between lg:gap-14" data-id="element-489" data-mp="tqikybe0suux">
          <div data-id="element-490" data-mp="orfsrrj52j4d">
            <p className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.3em] text-ink-950/70" data-id="element-491" data-mp="orxu32knrnj5">
              <TagIcon className="h-4 w-4" aria-hidden="true" data-id="element-492" data-mp="2hecc6hvmczew" />
              {discountOffer.eyebrow}
            </p>
            <h2 id="discount-heading" className="grit-headline mt-3 text-[clamp(2.5rem,9vw,5rem)] font-extrabold uppercase text-ink-950" data-id="element-493" data-mp="2r68btxdcsxl8">
              5 off your first X1.
            </h2>
            <p className="mt-3 max-w-xl text-[15px] font-medium text-ink-950/80 sm:text-base" data-id="element-494" data-mp="1yick772n5vvb">
              {discountOffer.body}
            </p>
          </div>

          <div className="w-full max-w-md shrink-0 bg-ink-950 p-6" data-id="element-495" data-mp="23iid0qkndoez">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-496" data-mp="27gpmd0cs7ng5">Your code</p>
            <div className="mt-3 flex items-center justify-between gap-4 border-2 border-dashed border-grit-500 px-4 py-3" data-id="element-497" data-mp="2cin9w6s7t4ew">
              <span className="font-display text-4xl font-extrabold uppercase tracking-[0.12em] text-grit-500" data-id="element-498" data-mp="3izsdn5i9f5r1">
                {discountOffer.code}
              </span>
              <button type="button" onClick={handleCopy} className="inline-flex shrink-0 items-center gap-2 bg-grit-500 px-4 py-2.5 font-display text-base font-extrabold uppercase text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px]" data-id="element-499" data-mp="1nsomg7tfk1ry">
                {copied ? <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-500" data-mp="154b5t8gnhbhy" /> : <CopyIcon className="h-4 w-4" aria-hidden="true" data-id="element-501" data-mp="106011c57pr6l" />}
                {copied ? 'Copied' : 'Copy'}
              </button>
            </div>

            <a href={REDIRECT_URL} data-buy-intent="true" onClick={event => {
            event.preventDefault();
            handleCopy();
          }} className="group mt-5 flex w-full items-center justify-center gap-3 bg-grit-500 px-6 py-4 font-display text-2xl font-extrabold uppercase tracking-wide text-ink-950 transition-[background-color,transform] duration-150 ease-grit hover:bg-grit-400 active:translate-y-[2px]" data-id="element-502" data-mp="1a2l3pqtreq79">
              {discountOffer.cta}
              <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-grit group-hover:translate-x-1" aria-hidden="true" data-id="element-503" data-mp="2k2p9b1ovdrrh" />
            </a>
            <p className="mt-3 text-[12px] text-steel-500" data-id="element-504" data-mp="3bstn2hi4jgjq">{discountOffer.note}</p>
          </div>
        </div>
      </div>
    </section>;
}